@if (!loading) {
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="grid w-full">
      <div class="col-12 xl:col-6 flex gap-2 flex-column">
        <label for="clientid">{{ i18n.i18nLng()['YOURMERCHANTID'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText id="clientid" fluid [(ngModel)]="editShopData.tenantId" [disabled]="true" pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="industry">
          {{ i18n.i18nLng()['INDUSTRY'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="editShopData.shopType"
                  inputId="industry"
                  [options]="settingsProvider.shopType"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="dataChanged()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['INDUSTRY']">
        </p-select>
      </div>
      <div class="col-12 flex gap-2 flex-column">
        <label for="organisationName">{{ i18n.i18nLng()['ORGANISATIONNAME'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText id="organisationName" fluid [(ngModel)]="organisationData.name" [disabled]="true" pSize="large"/>
      </div>
      <div class="col-12 flex gap-2 flex-column">
        <label for="streetNr">{{ i18n.i18nLng()['STREETNR'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText id="streetNr" fluid [(ngModel)]="organisationData.streetNr" [disabled]="true" pSize="large"/>
      </div>
      <div class="col-12 xl:col-4 flex gap-2 flex-column">
        <label for="postalcode">{{ i18n.i18nLng()['POSTALCODE'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText id="postalcode" fluid [(ngModel)]="organisationData.postalCode" [disabled]="true" pSize="large"/>
      </div>
      <div class="col-12 xl:col-8 flex gap-2 flex-column">
        <label for="city">{{ i18n.i18nLng()['CITY'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText id="city" fluid [(ngModel)]="organisationData.city" [disabled]="true" pSize="large"/>
      </div>
      <div class="col-12 flex gap-2 flex-column">
        <label for="weburl">{{ i18n.i18nLng()['WEBSITEURL'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText id="weburl" fluid [(ngModel)]="organisationData.url" [disabled]="true" pSize="large"/>
      </div>
    </div>
  </fieldset>
}
